import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export type SchedulingSmsForm = {
  sendDate: Date | null;
  sendTime: Date | null;
};

const TRANSLATE_SCHEDULING = 'CAMPAIGN_ACTIONS_MAIN.SMS_ACTION.SCHEDULING';

const useSchedulingForm = () => {
  const { t } = useTranslation();

  const { control, handleSubmit, setValue, watch, getValues, resetField, reset } =
    useForm<SchedulingSmsForm>();

  const RULES = {
    sendDate: {
      required: t(`${TRANSLATE_SCHEDULING}.RULES.dropdown`),
    },
    sendTime: {
      required: t(`${TRANSLATE_SCHEDULING}.RULES.dropdown`),
    },
  };

  return {
    getValues,
    control,
    RULES,
    setValue,
    watch,
    reset,
    handleSubmit,
    resetField,
  };
};

export default useSchedulingForm;
